import { render, staticRenderFns } from "./ClientsSideviewPaymentsTab.vue?vue&type=template&id=3b783248&scoped=true&class=fill-height&"
import script from "./ClientsSideviewPaymentsTab.vue?vue&type=script&lang=ts&"
export * from "./ClientsSideviewPaymentsTab.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsSideviewPaymentsTab.vue?vue&type=style&index=0&id=3b783248&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b783248",
  null
  
)

export default component.exports